import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileTxt.tsx
const IconFileTxt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#7f7574",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm2.686 2.716v3.378h-.912v-3.378H10.64v-.81h3.18v.81zm5.238 3.378h-1.056l-.906-1.542h-.018l-.882 1.542h-.984l1.344-2.166-1.278-2.022h1.062l.816 1.416h.018l.828-1.416h.984l-1.29 2.04zm2.303 0v-3.378h1.134v-.81h-3.18v.81h1.134v3.378z",
			clipRule: "evenodd"
		})
	]
});
var IconFileTxt_default = forwardRef(IconFileTxt);
//#endregion
export { IconFileTxt_default as default };
